<div class="mb-24">
  <div class="title title--big">Редактирование участка</div>
</div>

<app-sectors-create-edit-widget></app-sectors-create-edit-widget>
